import React from 'react';
import { RouteObject } from 'react-router-dom';

import { RoutePath } from '@constants/route-path';
import LoginPage from '@pages/LoginPage';
import NewBraceOrderPage from '@pages/NewBraceOrderPage';
import NewPatientPage from '@pages/NewPatientPage';
import PatientListPage from '@pages/PatientListPage';
import PaymentPage from '@pages/PaymentPage';
import ProfilePage from '@pages/ProfilePage';
import SignUpPage from '@pages/SignUpPage';
import SimulationReportPage from '@pages/SimulationReportPage';
import SinglePatientPage from '@pages/SinglePatientPage';
import ProtectedRoute from './ProtectedRoute';

export const routes: RouteObject[] = [
  {
    path: RoutePath.PatientListPage,
    element: (
      <ProtectedRoute>
        <PatientListPage />
      </ProtectedRoute>
    ),
  },
  {
    path: RoutePath.LoginPage,
    element: <LoginPage />,
  },
  {
    path: RoutePath.SignUpPage,
    element: <SignUpPage />,
  },
  {
    path: RoutePath.NewPatientPage,
    element: (
      <ProtectedRoute>
        <NewPatientPage />
      </ProtectedRoute>
    ),
  },
  {
    path: RoutePath.SinglePatientPage,
    element: (
      <ProtectedRoute>
        <SinglePatientPage />
      </ProtectedRoute>
    ),
  },
  {
    path: RoutePath.NewBraceOrderPage,
    element: (
      <ProtectedRoute>
        <NewBraceOrderPage />
      </ProtectedRoute>
    ),
  },
  {
    path: RoutePath.ProfilePage,
    element: (
      <ProtectedRoute>
        <ProfilePage />
      </ProtectedRoute>
    ),
  },
  {
    path: RoutePath.PaymentPage,
    element: (
      <ProtectedRoute>
        <PaymentPage />
      </ProtectedRoute>
    ),
  },
  {
    path: RoutePath.SimulationReportPage,
    element: (
      <ProtectedRoute>
        <SimulationReportPage />
      </ProtectedRoute>
    ),
  },
];
